<template>
  <div class="between_item between_right">
    <card title="预演实时数据">
      <div class="chart_box chart_box1">
        <div class="data_box fs box1 box_style">
          <div class="icon icon_s"><img src="../../assets/hs/icon_日发电量.png" alt="" /></div>
          <div class="info">
            <p class="num" :class="{ color1: isColor1, color2: isColor2 }">{{ actionState }}</p>
            <p>当前状态</p>
          </div>
        </div>
        <div class="data_box fs box1 box_style">
          <div class="icon icon_s"><img src="../../assets/hs/img_年发电量.png" alt="" /></div>
          <div class="info">
            <p class="num">{{ actionRain }}</p>
            <p>降雨量（mm）</p>
          </div>
        </div>
        <div class="data_box fs box1 box_style">
          <div class="icon icon_s"><img src="../../assets/hs/img_年发电量.png" alt="" /></div>
          <div class="info">
            <p class="num">{{ actionWater }}</p>
            <p>水库水位（m）</p>
          </div>
        </div>
        <div class="data_box fs box1 box_style">
          <div class="icon icon_s"><img src="../../assets/hs/img_当前发电功率.png" alt="" /></div>
          <div class="info">
            <p class="num">{{ actionEle }}</p>
            <p>机组出力（kW）</p>
          </div>
        </div>
        <!-- <div id="waterChart" ref="waterChart" class="water_echart"></div> -->
      </div>
    </card>
    <card title="机组运行曲线" styles="margin-top:24px">
      <div class="chart_box chart_box2 box_style">
        <div id="waterChart" ref="waterChart" class="water_echart"></div>
      </div>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import * as Api from '@/api';
let timerVisitChartData;
export default {
  components: {
    Card,
  },
  data() {
    return {
      waterChartOpt: {
        grid: {
          top: '10%',
          left: '3%',
          right: '5%',
          bottom: '3%',
          containLabel: true,
        },
        legend: {
          textStyle: {
            color: '#fff',
            fontSize: 16,
          },
        },
        xAxis: {
          name: '时间',
          type: 'category',
          boundaryGap: false,
          data: [],
          //x 轴线的颜色以及宽度
          show: true,
          axisTick: {
            show: false,
          },
          axisLabel: {
            //x 轴文字的配置
            show: true,
            textStyle: {
              color: '#86AAC4',
              fontSize: 16,
            },
          },
        },
        yAxis: [
          {
            // name: '机组出力/kw',
            nameTextStyle: { color: '#2FA3BE', fontSize: 14 },
            min: 0,
            max: 500,
            type: 'value',
            position: 'left',
            axisLine: {
              //y 轴线的颜色以及宽度
              show: true,
              lineStyle: {
                color: '#2FA3BE',
                width: 2,
              },
            },
            axisTick: {
              show: true,
            },
            axisLabel: {
              //y 轴文字的配置

              show: true,
              textStyle: {
                color: '#86AAC4',
                fontSize: 16,
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            // name: '水位/m',
            nameTextStyle: { color: '#86AAC4', fontSize: 14 },
            min: 520,
            max: 540,
            // data: [0, 100, 200, 300, 400, 500],
            position: 'right',
            type: 'value',
            axisLine: {
              //y 轴线的颜色以及宽度
              show: true,
              lineStyle: {
                color: '#2FA3BE',
                width: 2,
              },
            },
            axisTick: {
              show: true,
            },
            axisLabel: {
              //y 轴文字的配置

              show: true,
              textStyle: {
                color: '#86AAC4',
                fontSize: 16,
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '机组出力/kW',
            data: [0],
            type: 'line',
            yAxisIndex: 0,
            label: {
              show: false,
              rotate: -45,
              position: 'bottom',
              textStyle: {
                color: '#86AAC4',
                fontSize: 16,
              },
            },
            lineStyle: {
              color: '#2FA3BE',
              width: 2,
            },
            symbol: 'true', //不显示点
            areaStyle: {
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(57,192,210,0.23)',
                },
                {
                  offset: 1,
                  color: 'rgba(60,231,255,0)',
                },
              ]),
            },
            smooth: true,
          },
          {
            name: '水位/m',
            data: [0],
            type: 'line',
            yAxisIndex: 1,
            label: {
              show: false,
              rotate: -45,
              position: 'top',
              textStyle: {
                color: '#86AAC4',
                fontSize: 16,
              },
            },
            lineStyle: {
              color: '#86AAC4',
              width: 2,
            },
            symbol: 'true', //不显示点
            areaStyle: {
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(57,192,210,0.23)',
                },
                {
                  offset: 1,
                  color: 'rgba(60,231,255,0)',
                },
              ]),
            },
            smooth: true,
          },
        ],
      },
      isAction: false,
      actionRain: '--',
      actionWater: '--',
      actionEle: '--',
      actiontime: '0h',
      state: '--',
      isColor1: false,
      isColor2: false,
    };
  },
  mounted() {
    this.$bus.$on('isAction', (data) => {
      this.isAction = data;
      console.log('kaishile :>> ', data);
      if (data) {
        this.getPreviewData();
      } else {
        this.actionStop();
      }
    });
    this.renderCharts();
  },
  methods: {
    getPreviewData() {
      this.actionChart();
      Api.getPreviewSchemeContent().then((res) => {
        console.log(res);
      });
    },
    renderCharts() {
      let waterChart = this.$echarts.init(document.getElementById('waterChart'));
      waterChart.setOption(this.waterChartOpt);
    },
    actionChart() {
      let waterChart = this.$echarts.init(document.getElementById('waterChart'));

      let count = 0;
      const eleData = [];
      const waterData = [];
      const timeData = [];
      const chartArr = [
        { ele: 0, water: 527.15, rain: 0, time: '0小时', state: '降雨中' },
        { ele: 0, water: 527.25, rain: 3.15, time: '2小时', state: '降雨中' },
        { ele: 0, water: 527.55, rain: 5.07, time: '4小时', state: '降雨中' },
        { ele: 0, water: 527.53, rain: 6.11, time: '6小时', state: '降雨中' },
        { ele: 0, water: 528.63, rain: 7.89, time: '8小时', state: '降雨中' },
        { ele: 0, water: 529.11, rain: 9.88, time: '10小时', state: '降雨中' },
        { ele: 0, water: 529.57, rain: 8.72, time: '12小时', state: '水位上升' },
        { ele: 0, water: 530.95, rain: 9.14, time: '14小时', state: '水库溢流' },
        { ele: 0, water: 531.75, rain: 6.78, time: '16小时', state: '水库溢流' },
        { ele: 13.3, water: 531.98, rain: 5.12, time: '18小时', state: '机组启动' },
        { ele: 105.78, water: 531.78, rain: 4.38, time: '20小时', state: '机组启动中' },
        { ele: 169.6, water: 530.23, rain: 3.77, time: '22小时', state: '机组启动中' },
        { ele: 243.51, water: 529.45, rain: 1.19, time: '24小时', state: '机组启动中' },
        { ele: 280.34, water: 529.18, rain: 5.12, time: '26小时', state: '机组启动中' },
        { ele: 450.46, water: 529.14, rain: 6.33, time: '28小时', state: '机组启动中' },
        { ele: 500.12, water: 529.07, rain: 4.11, time: '30小时', state: '机组运行中' },
        { ele: 500.07, water: 529.18, rain: 3.52, time: '32小时', state: '机组运行中' },
        { ele: 500.12, water: 529.79, rain: 4.08, time: '36小时', state: '机组运行中' },
        { ele: 500.22, water: 529.96, rain: 5.32, time: '40小时', state: '机组满负荷' },
        { ele: 500.02, water: 528.23, rain: 3.02, time: '44小时', state: '机组运行中' },
        { ele: 500.78, water: 528.91, rain: 4.35, time: '48小时', state: '机组满负荷' },
      ];
      timerVisitChartData = setInterval(() => {
        eleData.push(chartArr[count].ele);
        waterData.push(chartArr[count].water);
        // timeData.push('T');
        timeData.push(chartArr[count].time);
        console.log('eleData :>> ', eleData);
        this.actionEle = chartArr[count].ele;
        this.actionWater = chartArr[count].water;
        this.actionRain = chartArr[count].rain;
        this.actionState = chartArr[count].state;
        waterChart.setOption({
          xAxis: { data: timeData },
          series: [{ data: eleData }, { data: waterData }],
        });
        count++;
        if (count == chartArr.length) {
          console.log('结束数据演示 :>> ');
          clearInterval(timerVisitChartData);
        }
      }, 2800);
    },
    actionStop() {
      let waterChart = this.$echarts.init(document.getElementById('waterChart'));
      waterChart.setOption({ series: [{ data: [] }, { data: [] }] });
      this.actionEle = '--';
      this.actionWater = '--';
      this.actionRain = '--';
      this.actionState = '--';
      clearInterval(timerVisitChartData);
      timerVisitChartData = null;
    },
  },
  beforeDestroy() {
    clearInterval(timerVisitChartData);
    this.$bus.$on('isAction');
  },
};
</script>

<style lang="scss" scoped>
.chart_box {
  width: 480px;
  height: 248px;
  &.chart_box2 {
    height: 360px;
  }
  .water_echart {
    width: 100%;
    height: 100%;
  }
  &.chart_box1 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
.data_box {
  flex: 0 0 auto;
  margin-bottom: 12px;
  &.box1 {
    width: 235px;
    min-height: 66px;
  }
  &.box2 {
    width: 230px;
    height: 118px;
  }
  &.box5,
  &.box6 {
    width: 238px;
    height: 130px;
  }
  .icon {
    &.icon_s {
      width: 56px;
      height: 56px;
      margin-left: 16px;
      img {
        display: block;
        width: 100%;
      }
    }
    &.icon_m {
      width: 84px;
      // height: 80px;
      margin-left: 8px;
      p {
        margin-top: 4px;
        text-align: center;
      }
    }
    img {
      display: block;
    }
  }
  .line {
    width: 1px;
    height: 102px;
    opacity: 0.25;
    border: 1px solid;
    border-image: linear-gradient(
        180deg,
        rgba(13, 165, 251, 0.05),
        rgba(33, 61, 222, 0.5),
        rgba(140, 235, 255, 0.55),
        rgba(38, 68, 245, 0.46),
        rgba(13, 169, 254, 0.19)
      )
      1 1;
    margin: 0 3px;
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: 8px;
    p {
      font-size: 18px;
    }
    .num {
      font-family: Roboto-Medium, Roboto;
      font-size: 28px;
      font-weight: bolder;
      color: #fff;
      text-shadow: 0px 0px 4px rgba(83, 143, 209, 0.7);
      margin-bottom: 5px;
      &.color1 {
        color: #ff0000;
      }
      &.color2 {
        color: #fdff66;
      }
    }
  }
}
</style>
